export var generatedAttribute = "generated";
export var mouseDownEvent = "pointerdown";
export var mouseUpEvent = "pointerup";
export var mouseLeaveEvent = "pointerleave";
export var mouseOutEvent = "pointerout";
export var mouseMoveEvent = "pointermove";
export var touchStartEvent = "touchstart";
export var touchEndEvent = "touchend";
export var touchMoveEvent = "touchmove";
export var touchCancelEvent = "touchcancel";
export var resizeEvent = "resize";
export var visibilityChangeEvent = "visibilitychange";
export var errorPrefix = "tsParticles - Error";